import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.date.to-string";
import "core-js/modules/es.object.create";
import "core-js/modules/es.object.define-property";
import "core-js/modules/es.object.get-prototype-of";
import "core-js/modules/es.object.set-prototype-of";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.reflect.construct";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from 'react';
import ChildWindow from '../../child-window/ChildWindow';
import Dialog from '../../dialog/Dialog';
import DialogContent from '../../dialog/DialogContent';
import DialogHeader from '../../dialog/DialogHeader';
import DialogFooter from '../../dialog/DialogFooter';
import DialogButtonContainer from '../../dialog/DialogButtonContainer';
import Button from '../../button/Button';
import Translatable from '../../translatable/Translatable';
import Markup from '../../markup/Markup';
import withStrings from '../../with-strings/with-strings';
import Block from '../../block/Block';
import navigation from '../../../lib/navigation/navigation';
import styles from './ConfirmModal.less';

var ConfirmModal = /*#__PURE__*/function (_Component) {
  _inherits(ConfirmModal, _Component);

  var _super = _createSuper(ConfirmModal);

  function ConfirmModal() {
    var _this;

    _classCallCheck(this, ConfirmModal);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "onAccept", function () {
      var _this$props = _this.props,
          navigationUrl = _this$props.navigationUrl,
          dataDisplayType = _this$props.dataDisplayType,
          dataLinkType = _this$props.dataLinkType;

      _this.props.onFrameworkClose();

      navigation({
        navigationUrl: navigationUrl,
        displayType: dataDisplayType,
        samlDetails: {
          browserMode: dataLinkType
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onDecline", function () {
      _this.props.onFrameworkClose();
    });

    return _this;
  }

  _createClass(ConfirmModal, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          isOpen = _this$props2.isOpen,
          onFrameworkClose = _this$props2.onFrameworkClose,
          getString = _this$props2.getString;
      return /*#__PURE__*/React.createElement(Dialog, {
        isOpen: isOpen,
        onFrameworkClose: onFrameworkClose
      }, /*#__PURE__*/React.createElement(DialogHeader, null, /*#__PURE__*/React.createElement(Markup, {
        content: getString('global.wf.leave.title'),
        className: styles.heading
      })), /*#__PURE__*/React.createElement(DialogContent, null, /*#__PURE__*/React.createElement(Block, {
        tabIndex: "0",
        className: styles.content
      }, /*#__PURE__*/React.createElement(Markup, {
        el: "p",
        content: getString('global.wf.leave.confirm.one')
      }), /*#__PURE__*/React.createElement(Markup, {
        el: "p",
        content: getString('global.wf.leave.confirm.two')
      }))), /*#__PURE__*/React.createElement(DialogFooter, null, /*#__PURE__*/React.createElement(DialogButtonContainer, {
        horizontal: true
      }, /*#__PURE__*/React.createElement(Button, {
        buttonType: "secondary",
        onClick: this.onDecline
      }, /*#__PURE__*/React.createElement(Translatable, {
        id: "global.cancel",
        defaultMessage: "Cancel"
      })), /*#__PURE__*/React.createElement(Button, {
        buttonType: "primary",
        onClick: this.onAccept
      }, /*#__PURE__*/React.createElement(Translatable, {
        id: "global.continue",
        defaultMessage: "Continue"
      })))));
    }
  }]);

  return ConfirmModal;
}(Component);

export default withStrings(ChildWindow(ConfirmModal));